import { apiClient } from './api';
import type { NotificationOut } from '@/types/notification';

// ─── Notification API ─────────────────────────────────────────────────────────

export interface UnreadCountResponse {
  unread_count: number;
}

export interface MarkAllReadResponse {
  marked: number;
}

export interface ListNotificationsParams {
  unread?: boolean;
  limit?: number;
  offset?: number;
}

/**
 * Fetch the current user's unread notification count.
 * GET /api/notifications/unread_count
 */
export async function getUnreadCount(): Promise<UnreadCountResponse> {
  const { data } = await apiClient.get<UnreadCountResponse>('/notifications/unread_count');
  return data;
}

/**
 * Fetch a list of the current user's notifications.
 * GET /api/notifications
 */
export async function listNotifications(
  params?: ListNotificationsParams
): Promise<NotificationOut[]> {
  const { data } = await apiClient.get<NotificationOut[]>('/notifications', { params });
  return data;
}

/**
 * Mark a single notification as read (idempotent).
 * POST /api/notifications/{id}/read
 */
export async function markRead(id: string): Promise<NotificationOut> {
  const { data } = await apiClient.post<NotificationOut>(`/notifications/${id}/read`);
  return data;
}

/**
 * Mark all of the current user's notifications as read.
 * POST /api/notifications/mark_all_read
 */
export async function markAllRead(): Promise<MarkAllReadResponse> {
  const { data } = await apiClient.post<MarkAllReadResponse>('/notifications/mark_all_read');
  return data;
}
